import React, { Component } from 'react';
import Translator from '../../../../requests/apa/Translator';
import Assets from '../../../../requests/apa/Asset';
import DeviceStorage from '../../../DeviceStorage/DeviceStorage';
import Utils from '../../../../utils/Utils';

class LastPage extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            imageLeftError: false,
            imageRight1Error: false,
            imageRight2Error: false,
            imageRight3Error: false,
            imageRight4Error: false
        }
    }

    componentDidMount() {
        setTimeout(() => {
            window.SpatialNavigation.focus('.btn.focusable');
        }, 0)
    }

    render() {

        const {
            updateForced: {enable: isEnabledUpdateForced},
        } = Utils.getApaMetadataKey('migration_landing_config', `{"updateForced": {"enable": true}}`);

        const title = Translator.get('LandingPageClaroTv04_Titulo_TextoTitulo', "¡Haz tu actualización!");

        const region = DeviceStorage.getItem("region");
        const defaultImageLeft = Assets.get('LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero01', '')
        const imageLeft = Assets.get(`LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero01_${region}`, '') || defaultImageLeft;
        const defaultImageRight1 = Assets.get('LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero02', '')
        const imageRight1 = Assets.get(`LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero02_${region}`, '') || defaultImageRight1;
        const defaultImageRight2 = Assets.get('LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero03', '')
        const imageRight2 = Assets.get(`LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero03_${region}`, '') || defaultImageRight2;
        const defaultImageRight3 = Assets.get('LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero04', '')
        const imageRight3 = Assets.get(`LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero04_${region}`, '') || defaultImageRight3;
        const defaultImageRight4 = Assets.get('LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero05', '')
        const imageRight4 = Assets.get(`LandingPageClaroTv04_Metadata02_Imagen_ImagenNumero05_${region}`, '') || defaultImageRight4;

        return (
            <div className="landing-page_page last-page">
                <div className="content">
                    <h1>{title}</h1>
                    <div>
                        <div className="image-left-container">
                            <img src={this.state.imageLeftError ? defaultImageLeft : imageLeft} 
                                onError={this.state.imageLeftError ? () => {} : () => {
                                    this.setState({imageLeftError: true})
                                }}
                            />
                        </div>                    
                        <div className="image-right-container">
                            <img src={this.state.imageRight1Error ? defaultImageRight1 : imageRight1} 
                                onError={this.state.image1Error ? () => {} : () => {
                                    this.setState({image1Error: true})
                                }}
                            />
                            <img src={this.state.imageRight2Error ? defaultImageRight2 : imageRight2} 
                                onError={this.state.imageRight2Error ? () => {} : () => {
                                    this.setState({imageRight2Error: true})
                                }}
                            />
                            <img src={this.state.imageRight3Error ? defaultImageRight3: imageRight3} 
                                onError={this.state.imageRight3Error ? () => {} : () => {
                                    this.setState({imageRight3Error: true})
                                }}
                            />
                            {
                                isEnabledUpdateForced && 
                                <img src={this.state.imageRight4Error ? defaultImageRight4 : imageRight4} 
                                    onError={this.state.imageRight4Error ? () => {} : () => {
                                        this.setState({imageRight4Error: true})
                                    }}
                                />
                            }
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

export default LastPage;


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPageSTB/pages/LastPage.jsx